import { render, staticRenderFns } from "./ArchiveManage.vue?vue&type=template&id=a10e8926&scoped=true"
import script from "./ArchiveManage.vue?vue&type=script&lang=ts"
export * from "./ArchiveManage.vue?vue&type=script&lang=ts"
import style0 from "./ArchiveManage.vue?vue&type=style&index=0&id=a10e8926&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10e8926",
  null
  
)

export default component.exports